import * as React from "react";
import {ReactElement} from "react";
import {useStoreValue} from "react-context-hook";
import Icon from "../Icon";
import BookingTravelers from "../BookingTravelers";
import {getText} from "../../services/configuration.service";
import * as DOMPurify from "dompurify";
import {paxSelectConfig} from "../../../config/pax";

export interface PaxProps {
    pax: Pax;
    childrenError: any;
    paxError: any;
}

export interface Pax {
    nbAdults: number;
    nbChildren: number;
    children: any;
}

export interface BirthdateProps {
    day: ValueLabel;
    month: ValueLabel;
    year: ValueLabel;
}

export interface ValueLabel {
    value: any;
    label: any;
}

const BookingPax = (): ReactElement => {

    /**
     * TODO :
     * - add label in properties files
     */

    const pax = useStoreValue("pax");
    const maxPax = useStoreValue("maxPax");
    const nbAdults = pax.nbAdults;
    const nbChildren = pax.nbChildren;
    const titleLegend = getText("booking.passenger.legend").replace("${maxPax}", maxPax || paxSelectConfig.adult.options.length);

    return (
        <div className="booking-item js-switch-active">
            <div className="label">Voyageurs</div>
            <div className="elem-custom-select">
                <div className="custom-select-mask">
                    <div className="custom-select-input">
                        <div className="custom-select-input-txt">
                            <Icon icon={"M"} addClass={"users-icon"}/>
                            <div className="label-style">{nbAdults} adulte(s) | {nbChildren} enfant(s)</div>
                        </div>
                        <div className="custom-select-input-button">Modifier</div>
                    </div>
                </div>
                <div className="custom-select-panel d-none">
                    <div className="title-block">
                        <div className="label-block">
                            <div className="label">Voyageurs</div>
                            <div className="legend" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(titleLegend)}}/>
                        </div>
                        <div className="icon-wrap btn-close-custom-select">
                            <Icon icon={"x"}/>
                        </div>
                    </div>
                    <div className="custom-select-panel-content">
                        <BookingTravelers/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookingPax;
